import { Logger, ILogObj } from 'tslog';

export const log: Logger<ILogObj> = new Logger({
    // 0: silly, 1: trace, 2: debug, 3: info, 4: warn, 5: error, 6: fatal
    minLevel: (process.env['NX_PUBLIC_TS_LOG_LEVEL'] as unknown as number) || 1,
    type: process.env['NX_PUBLIC_TS_LOGGER_ENABLE'] == 'true' ? 'pretty' : 'hidden',
});
